// eslint-disable-next-line no-restricted-imports
import { CookieAttributes } from "js-cookie";
import { eventBus, GlobalEvents } from "../global-events";
// eslint-disable-next-line no-restricted-imports
import { useCookieStorage, useLocalStorage, useSessionStorage } from "../use-storage";
import { useWebStorageTest } from "./use-web-storage-test";
import { WebStorageType } from "./web-storage-type";
import { CookieType } from "../gdpr/wecoma-models";

type QueueItemType = {
    itemName: string;
    value: string;
    storageType: WebStorageType | "cookie";
    cookieType: CookieType;
    cookieAttributes?: CookieAttributes;
};

// items in memory queue waiting for consent
const storageQueue: QueueItemType[] = [];

eventBus.on(GlobalEvents.ConsentsChanged, () => processStorageQueue());

function processStorageQueue() {
    const cookieStorage = useCookieStorage();
    const localStorage = useLocalStorage();
    const sessionStorage = useSessionStorage();

    storageQueue.forEach((item) => {
        if (useWebStorageTest().canSetValue(item.cookieType)) {
            switch (item.storageType) {
                case "cookie":
                    cookieStorage.setItem(item.itemName, item.value, item.cookieType, item.cookieAttributes);
                    break;
                case "localStorage":
                    localStorage.setItem(item.itemName, item.value, item.cookieType);
                    break;
                case "sessionStorage":
                    sessionStorage.setItem(item.itemName, item.value, item.cookieType);
                    break;
            }
        }
    });
}

export const useWebStorageQueue = () => {
    const enqueue = (item: QueueItemType) => {
        storageQueue.push(item);
    };

    return {
        enqueue,
    };
};
